import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';
import { ConfigService } from '../config.service';
import { BaseConfig } from '../models/config.model';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  baseConfig: BaseConfig;

  updateTitle(): void {
    this.title.setTitle(this.getTitle());
  }

  constructor(
    private title: Title,
    private configService: ConfigService,
  ) {
    super();
    this.configService.getConfig().subscribe((config) => {
      this.baseConfig = config;
      this.title.setTitle(this.getTitle());
    });
  }

  private getTitle(): string {
    return this.baseConfig &&
      this.baseConfig.pageTitle &&
      this.baseConfig.pageTitle.length > 0
      ? this.baseConfig.pageTitle
      : 'embraceableAI Console';
  }
}
